import React from 'react'
import SpaHeader from '../Header/SpaHeader'
import MediaQuery from 'react-responsive'
import LoadingOverlay from 'react-loading-overlay';
import { SpaBreadcrumb } from '../index'
import LoaderImg from '../../images/ajax_loader.gif'

const loader = (<span className='filter-spa-loading-text-container'>
    <img alt='Loader-spinner' width='35px' height='35px' src={LoaderImg} /><span className='services-loading-text font-size-p5 gotham-xn-medium' role="alert" aria-live="polite" aria-busy="true">Loading</span>
</span>);
export const SpaLayout = (props) => {
    return (
        <div className={props.appTrigger === 'CP' ? 'cp-wrapper' : 'polar-wrapper'} aria-live="polite" aria-busy={props.isScreenLoading}>
            <LoadingOverlay
                active={props.isScreenLoading}
                spinner={loader}
            >
                <MediaQuery query="(min-width: 767px)">
                    {(matches) => (
                        <div style={(!props.cpNavdata || props.cpNavdata === 'none') ? { marginTop: '0' } : {}} className={`${matches ? 'spa-breadcrumb-adjust' : ''}`}>
                            <SpaBreadcrumb cart={props.cart} items={props.items || []} />
                        </div>
                    )}
                </MediaQuery>

                {props.children}
            </LoadingOverlay>
        </div>
    )
}
